module.exports = __webpack_public_path__ + "static/media/benefits2.f3f4e358.png";